"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PublicWifiSecurityCTA() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const stats = [{
    value: "256-bit",
    label: "encryption",
    align: "left"
  }, {
    value: "100% PRIVACY",
    label: "guaranteed",
    align: "right"
  }, {
    value: "99.9%",
    label: "uptime rate",
    align: "left"
  }];
  return <section data-section-id="2138" id="publicwifisecuritycta" className="relative overflow-hidden bg-background text-foreground py-24 md:py-44 px-5 sm:px-8 lg:px-18">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute font-serif select-none leading-none" style={{
      fontSize: "clamp(12rem, 22vw, 22rem)",
      fontWeight: 200,
      color: "hsl(221 40% 4% / 0.05)",
      top: "8%",
      left: "2%",
      letterSpacing: "-0.05em"
    }}>
        04
      </div>

      <div className="relative mx-auto max-w-[1440px] grid grid-cols-12 gap-6 md:gap-8 items-start">
        {}
        <div ref={leftRef} className="col-span-12 lg:col-span-5 order-2 lg:order-1 flex flex-col" style={{
        opacity: leftVisible ? 1 : 0,
        transform: leftVisible ? "translateY(0)" : "translateY(24px)",
        transition: "opacity 640ms cubic-bezier(0.22, 1, 0.36, 1), transform 640ms cubic-bezier(0.22, 1, 0.36, 1)"
      }}>
          {}
          <div className="flex items-center gap-3 mb-8">
            <span aria-hidden="true" className="inline-block h-px w-6 bg-border" />
            <span className="font-mono uppercase text-muted-foreground" style={{
            fontSize: "clamp(0.6875rem, 0.78vw, 0.8125rem)",
            fontWeight: 500,
            letterSpacing: "0.18em",
            lineHeight: 1
          }}>
              § N° 04 — SECURITY
            </span>
          </div>

          {}
          <h2 className="font-serif mb-8 text-foreground" style={{
          fontSize: "clamp(2.25rem, 4.2vw, 4.25rem)",
          fontWeight: 400,
          lineHeight: 1.02,
          letterSpacing: "-0.02em"
        }}>
            Secure your data on{" "}
            <span className="italic" style={{
            fontVariationSettings: "'opsz' 12",
            fontWeight: 400
          }}>
              public
            </span>{" "}
            networks.
          </h2>

          {}
          <p className="mb-12 max-w-xl text-muted-foreground" style={{
          fontSize: "clamp(1.0625rem, 1.15vw, 1.25rem)",
          fontWeight: 400,
          lineHeight: 1.6,
          letterSpacing: "-0.005em"
        }}>
            Our advanced VPN protocols are engineered for total digital safety — shielding your traffic from prying eyes, masking your location, and ensuring your connection remains private on any public Wi-Fi.
          </p>

          {}
          <div className="flex flex-col gap-7 mb-12">
            {stats.map((stat, i) => <div key={i} data-index={i} className={`flex items-center gap-5 ${stat.align === "right" ? "flex-row-reverse text-right" : ""}`}>
                <div className="relative flex items-center flex-1 min-w-0">
                  <span className="h-px flex-1 bg-border" />
                  <span aria-hidden="true" className="block h-1.5 w-1.5 rounded-lg ml-0 bg-primary" />
                </div>
                <div className="flex items-baseline gap-3 shrink-0">
                  <span className="font-serif text-foreground" style={{
                fontSize: "clamp(1.75rem, 2.5vw, 2.5rem)",
                fontWeight: 400,
                letterSpacing: "-0.02em",
                lineHeight: 1
              }}>
                    {stat.value}
                  </span>
                  <span className="font-mono uppercase text-muted-foreground" style={{
                fontSize: "0.6875rem",
                letterSpacing: "0.18em"
              }}>
                    / {stat.label}
                  </span>
                </div>
              </div>)}
          </div>

          {}
          <div className="flex flex-col sm:flex-row gap-4">
            <Link to="https://vpngenix.com/go/NordVPN" newTab>
              <Button className="rounded-lg px-8 py-6 h-auto font-sans uppercase transition-all duration-[220ms] ease-out hover:-translate-y-0.5 bg-primary text-primary-foreground" style={{
              fontSize: "0.8125rem",
              fontWeight: 500,
              letterSpacing: "0.04em",
              borderRadius: "999px"
            }}>
                Get Protected Now
              </Button>
            </Link>
            <Link to="/BlogsPage">
              <Button variant="outline" className="rounded-lg px-8 py-6 h-auto font-sans uppercase bg-transparent transition-colors duration-[220ms] ease-out border-foreground text-foreground" style={{
              fontSize: "0.8125rem",
              fontWeight: 500,
              letterSpacing: "0.04em",
              borderRadius: "999px",
              borderWidth: "1px"
            }}>
                Read Security Tips
              </Button>
            </Link>
          </div>
        </div>

        {}
        <div ref={rightRef} className="col-span-12 lg:col-span-7 order-1 lg:order-2" style={{
        opacity: rightVisible ? 1 : 0,
        transform: rightVisible ? "translateY(0)" : "translateY(24px)",
        transition: "opacity 640ms cubic-bezier(0.22, 1, 0.36, 1) 80ms, transform 640ms cubic-bezier(0.22, 1, 0.36, 1) 80ms"
      }}>
          <div className="relative w-full" style={{
          aspectRatio: "16 / 10"
        }}>
            {}
            <span aria-hidden="true" className="absolute top-0 left-0 z-10 border-t border-l border-border" style={{
            width: "8px",
            height: "8px"
          }} />
            <span aria-hidden="true" className="absolute top-0 right-0 z-10 border-t border-r border-border" style={{
            width: "8px",
            height: "8px"
          }} />
            <span aria-hidden="true" className="absolute bottom-0 left-0 z-10 border-b border-l border-border" style={{
            width: "8px",
            height: "8px"
          }} />
            <span aria-hidden="true" className="absolute bottom-0 right-0 z-10 border-b border-r border-primary" style={{
            width: "8px",
            height: "8px"
          }} />

            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1729652/img/vpngenix_secure_connection.png" alt="Encrypted VPN connection interface on a laptop screen in a public cafe setting" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover" />

            {}
            <div className="absolute bottom-4 left-4 z-10 font-mono uppercase text-background" style={{
            fontSize: "0.6875rem",
            letterSpacing: "0.08em",
            lineHeight: 1.2,
            mixBlendMode: "difference"
          }}>
              Security Protocol — VPNGENIX / 2024
            </div>
          </div>
        </div>
      </div>
    </section>;
}